import { IResponse } from "../interfaces/IResponse";
import { BisAPI } from "./apis";

export const getRolByUserID = (userID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisAPI.get(`/Proyecto/ObtenerRolesByUsuarioIDAndProyectoID?usuarioID=${userID}`)
            .then((response: any) => {
                resolve(response.data);
            })
            .catch((error: any) => {
                reject(error?.response?.data);
            })
    })
}
